// Renders the toasts raised through toast.ts, bottom right (above the phone tab bar).
import { CheckCircle, Warning } from "@phosphor-icons/react";
import { useEffect, useState } from "react";

import { cn } from "../ui/cn";
import { subscribe, type ToastItem } from "./toast";

export function Toaster({ ttlMs = 3400 }: { ttlMs?: number }) {
  const [items, setItems] = useState<ToastItem[]>([]);
  useEffect(() => {
    const timers = new Set<ReturnType<typeof setTimeout>>();
    const unsubscribe = subscribe((t) => {
      setItems((xs) => [...xs, t]);
      const timer = setTimeout(() => {
        timers.delete(timer);
        setItems((xs) => xs.filter((x) => x.id !== t.id));
      }, ttlMs);
      timers.add(timer);
    });
    return () => {
      unsubscribe();
      timers.forEach(clearTimeout);
    };
  }, [ttlMs]);

  return (
    <div className="pointer-events-none fixed bottom-24 end-4 z-[1000] flex flex-col items-end gap-2 md:bottom-5 md:end-5" role="status" aria-live="polite">
      {items.map((t) => (
        <div
          key={t.id}
          data-tone={t.tone}
          className={cn(
            "flex animate-toast-in items-center gap-2.5 rounded-xl border bg-gray-0 px-4 py-2.5 text-[13px] font-medium text-gray-900 shadow-float dark:bg-gray-100",
            t.tone === "warn" ? "border-orange/50" : "border-muted",
          )}
        >
          {t.tone === "warn" ? (
            <Warning weight="fill" className="h-[18px] w-[18px] shrink-0 text-orange" />
          ) : (
            <CheckCircle weight="fill" className="h-[18px] w-[18px] shrink-0 text-green" />
          )}
          {t.msg}
        </div>
      ))}
    </div>
  );
}
